import { Typography } from '@material-ui/core';
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import FiltersContext from '../../contexts/FiltersContext';
// import states, { stateFIPS } from '../../modules/states';
import { stateFIPS } from '../../modules/states';
// import { toFormattedNumber, toPercent } from '../../modules/text';
import { toFormattedNumber } from '../../modules/text';
// import povertyIncome, { getRatesByState } from './data';
import { composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import NoDataVisual from '../NoDataVisual';
import { years } from '../../modules/years';

function ProvidersChange() {
  const { stateCode } = useParams();
  const [error, setError] = useState(null);
  const { displayBy } = useContext(FiltersContext);
  const [, setReady] = useState(false);
  const [data, setData] = useState({});
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    setError(null);
    setReady(false);
    const getCapacity = function getCapacity() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      whereClause += composeWhereClause({}, true, false); // don't use child age

      let measure = 'capacity:SUM(capacity_tot)';
      if (displayBy === 'Providers') {
        measure = 'capacity:SUM(cnt_provider)';
      }

      return rdsTabulate('ccdc', 'tract_licensed_capacity', {
        dims: 'wave_id',
        measure,
        where: whereClause,
        format: 'amcharts',
        orderby: 'wave_id',
      }, false, null); // use cache, unset wave
    };

    getCapacity().then((response) => {
      const dataItems = response.parsedBody.dataProvider;
      if (dataItems.length === 0) {
        setNoData(true);
        return;
      }
      let dataObject = {};
      dataItems.forEach((di) => {
        const label = di.wave_id === years.rdsCovidWave.toString() ? 'from' : 'to';
        const v = {};
        v[label] = di.capacity;
        dataObject = { ...dataObject, ...v };
      });
      setData(dataObject);
    })
      .catch((e) => {
        setError(e);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode, displayBy]);

  if (noData) {
    return <NoDataVisual />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      Prior to the outbreak of COVID-19, there were <b>{toFormattedNumber(data.from)}</b> licensed <b>{displayBy.toLowerCase()}</b>.
      As of {years.covidToMonthYear}, there were <b>{toFormattedNumber(data.to)}</b> licensed <b>{displayBy.toLowerCase()}</b>.
      The bar charts below compare the change in the number of providers or slots by provider type and subsidy acceptance.
      Use the toggle to view the number of providers or slots.

    </>
  );
}

export default ProvidersChange;
